import styled from 'styled-components'

export const AaPlatformStyled = styled.div`
  color: ${({ theme }) => theme.COLORS.RED_1};
`
